import React, { FC } from 'react'

import { usePrices } from 'src/hooks/usePrices'
import { PriceType } from 'src/types/prices'

import PriceDetails, { PriceDetailsProps } from 'client/components/PriceDetails'
import PriceDetailsRefined, {
  PriceDetailsRefinedProps,
} from 'client/components/PriceDetailsRefined'

export type PriceDetailsFactoryProps = PriceDetailsProps | PriceDetailsRefinedProps

export type PriceDataType = Omit<
  PriceDetailsFactoryProps,
  | 'variant'
  | 'showDiscount'
  | 'showPaymentDates'
  | 'showWalletCheckbox'
  | 'purchaseId'
  | 'isVoucher'
>

const PriceDetailsMap = {
  [PriceType.Net]: PriceDetails,
  [PriceType.Gross]: PriceDetails,
  [PriceType.TrivagoNet]: PriceDetails,
  [PriceType.AllIn]: PriceDetailsRefined,
  [PriceType.AllInDaily]: PriceDetailsRefined,
  [PriceType.NetWithFees]: PriceDetailsRefined,
  [PriceType.NetWithFeesDaily]: PriceDetailsRefined,
}

const PriceDetailsFactory = (props: PriceDetailsFactoryProps) => {
  const { priceType } = usePrices({ rooms: [] })

  const PriceDetailsComponent = PriceDetailsMap[priceType] as FC<PriceDetailsFactoryProps>
  return <PriceDetailsComponent {...props} />
}

export default PriceDetailsFactory
